import { render, staticRenderFns } from "./Page_Shop.vue?vue&type=template&id=5bbbab36&scoped=true&"
import script from "./Page_Shop.vue?vue&type=script&lang=js&"
export * from "./Page_Shop.vue?vue&type=script&lang=js&"
import style0 from "./Page_Shop.vue?vue&type=style&index=0&id=5bbbab36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbbab36",
  null
  
)

export default component.exports